import type { DeepPartial } from '@luna/utils-ts';

import type { NavigationFeatureConfig } from './type';

export const navigation: DeepPartial<NavigationFeatureConfig> = {
    settingsDropdown: {
        businessBankingLink: true,
    },
};
